import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setPageHeadingAction } from "@src/layout/store/actions";

const usePageHeading = (props) => {
    const { heading, deps = [] } = props || {};
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageHeadingAction(heading || ""));

    return () => {
      dispatch(setPageHeadingAction());
    };
  }, [heading, ...deps]);
};

export default usePageHeading;